import getEnvironment from '../helpers/getEnvironment';
import localConfig from './config/config.local';
import stgConfig from './config/config.stg';
import prodConfig from './config/config.prod';

const getConfig = () => {
	const environment = getEnvironment();

	if (environment === 'local') return localConfig;
	else if (environment === 'stg') return stgConfig;
	else if (environment === 'prod') return prodConfig;

	return localConfig;
};

export default {
	app: {
		booted: false,
		filters: {},
		activeApiCalls: [],
		isLoggedIn: false,
		token: localStorage.getItem('token'),
		toggleHamburgerMenu: false,
		featureFlags: {},
		constants: {},
		metaData: {},
		// clientEnv: 'stg',
		clientEnv: getEnvironment(),
		clientApp: 'cms',
	},

	modal: {
		visible: false,
		windows: [],
	},

	auth: {
		user: null,
	},

	// TODO :: make endpoints for own environment in same file so you only have to specify host
	config: getConfig(),

	user: {
		profile: null,
	},

	notification: {
		toast: [],
		fullscreen: [],
	},

	sidebar: {
		pages: [],
		transition: true,
	},

	sandbox: {
		exchangeRates: [],
	},

	users: {

	},

	settings: {
		featureFlags: [],
		metaData: [],
		constants: {},
		logs: {
			email: {},
		},
	},

	cms: {
		navigation: {},
		pages: {},
		articles: {},
		contacts: {},
		assets: {},
		popups: {},
		users: {},
		projectIcons: {},
		permissions: {},
		siteSettings: {},
	},

	pos: {
		pages: {},
	},

	ppc: {
		faq: {},
		forms: {},
		page: {
			details: {},
			index: {},
		},
		product: {
			category: {},
			details: {},
			index: {},
		},
		service: {
			category: {},
			details: {},
			index: {},
		},
		location: {
			details: {},
			index: {},
		},
		associations: {},
		clients: {},
		contacts: {},
		construxHomeSlider: [],
		testimonials: {},
		calendarEvents: [],
	},

	assetViewer: {
		index: {},
		details: {},
		paginationCompleted: false,

		filters: {
			type: null,
			searchString: '',
			page: 0,
			by: 'dateAdded',
			asc: false,
		},
	},
};
